import React, { useState } from "react";
import LearningSessionResultNav from "../LearningSessionResultNav/LearningSessionResultNav";
import LiveSessionResult from "../LiveSessionResult/LiveSessionResult";
import RequestForCertificate from "../RequestForCertificate/RequestForCertificate";

const LearningSessionResult = () => {
  const [checkResult, setCheckResult] = useState(0);
  // const [requestCertificate, setRequestCertificate] = useState(false);

  return (
    <div>
      <LearningSessionResultNav
        checkResult={checkResult}
        setCheckResult={setCheckResult}
      />
      {checkResult === 1 && <LiveSessionResult />}
      {checkResult === 2 && <RequestForCertificate />}
    </div>
  );
};

export default LearningSessionResult;
